import escapeHtml from "escape-html";
import { RichTextNodeType, LinkType } from "@prismicio/types";
import { asLink } from "../asLink.js";
var getLabel = function getLabel(node) {
  return "data" in node && "label" in node.data ? " class=\"".concat(node.data.label, "\"") : "";
};
var serializeStandardTag = function serializeStandardTag(tag, node, children) {
  return "<".concat(tag).concat(getLabel(node), ">").concat(children.join(""), "</").concat(tag, ">");
};
var serializePreFormatted = function serializePreFormatted(node) {
  return "<pre".concat(getLabel(node), ">").concat(escapeHtml(node.text), "</pre>");
};
var serializeImage = function serializeImage(linkResolver, node) {
  var imageTag = "<img src=\"".concat(node.url, "\" alt=\"").concat(escapeHtml(node.alt), "\"").concat(node.copyright ? " copyright=\"".concat(escapeHtml(node.copyright), "\"") : "", " />");
  if (node.linkTo) {
    imageTag = serializeHyperlink(linkResolver, {
      type: RichTextNodeType.hyperlink,
      data: node.linkTo,
      start: 0,
      end: 0
    }, [imageTag]);
  }
  return "<p class=\"block-img\">".concat(imageTag, "</p>");
};
var serializeEmbed = function serializeEmbed(node) {
  return "<div data-oembed=\"".concat(node.oembed.embed_url, "\" data-oembed-type=\"").concat(node.oembed.type, "\" data-oembed-provider=\"").concat(node.oembed.provider_name, "\"").concat(getLabel(node), ">").concat(node.oembed.html, "</div>");
};
var serializeHyperlink = function serializeHyperlink(linkResolver, node, children) {
  switch (node.data.link_type) {
    case LinkType.Web:
      {
        return "<a href=\"".concat(escapeHtml(node.data.url), "\" ").concat(node.data.target ? "target=\"".concat(node.data.target, "\" ") : "", "rel=\"noopener noreferrer\"").concat(getLabel(node), ">").concat(children.join(""), "</a>");
      }
    case LinkType.Document:
      {
        return "<a href=\"".concat(asLink(node.data, linkResolver), "\"").concat(getLabel(node), ">").concat(children.join(""), "</a>");
      }
    case LinkType.Media:
      {
        return "<a href=\"".concat(node.data.url, "\"").concat(getLabel(node), ">").concat(children.join(""), "</a>");
      }
  }
};
var serializeSpan = function serializeSpan(content) {
  return content ? escapeHtml(content).replace(/\n/g, "<br />") : "";
};
export { getLabel, serializeEmbed, serializeHyperlink, serializeImage, serializePreFormatted, serializeSpan, serializeStandardTag };